import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

import { Translate } from '@change-corgi/core-react/i18n';

export const Buttons: React.FC<EmptyProps> = () => {
	return (
		<Button type="submit" variant="primary" data-qa="report-abuse-submit-button">
			<Translate value="fe.components.petition_report_abuse.form_submit" />
		</Button>
	);
};
